// extracted by mini-css-extract-plugin
export default {"mCard":"oE-z","image":"pE-z","imageNoBackground":"qE-z","imageHasCategory":"rE-z","fullWidth":"sE-z"};